import { render, staticRenderFns } from "./times.vue?vue&type=template&id=71c51280&"
import script from "./times.vue?vue&type=script&lang=js&"
export * from "./times.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports